export const saveScrollTop = (pos) => ({
  type: 'SAVE_SCROLL_TOP',
  payload: pos
});
export function saveCurrentDisplayingCatName(catName) {
  return {
    type: 'CATEGORY_DISPLAYING_SET',
    payload: catName
  };
}
export function setCurrentCategoryAndPosition(name, pos) {
  return {
    type: 'CATEGORY_POSITION_SET',
    payload: {name, position: pos}
  };
}
export function scrollTo(pos = 1) {
  setTimeout(() => {
    window.scrollTo(0, pos);
  }, 0);

  return {
    type: 'SCROLL_TO',
  };
}
export function setScrollDirection(direction) {
  if (direction === 'down') {
    return {
      type: 'SCROLL_DOWN'
    };
  }
  return {
    type: 'SCROLL_UP'
  };
    
}
export function setNavBarTitle(name) {
  return {
    type: 'NAV_BAR_TITLE_SET',
    payload: name
  };
}
export function setEnv(name) {
  return {
    type: 'ENV_SET',
    payload: name
  };
}
export const showScrollView = () => ({
  type: 'SHOW_SCROLL_VIEW'
});

export const openFilterBar = () => ({
  type: 'FILTERBAR_OPEN'
});

export const closeFilterBar = () => ({
  type: 'FILTERBAR_CLOSE'
});



// WEBPACK FOOTER //
// ./src/actions/view.js